import i18next from 'i18next';
import translations from './translations/translations.es.json';

i18next
  .init({
    interpolation: {
      // React already does escaping
      escapeValue: false,
    },
    lng: 'es', // 'en' | 'es'
    // Using simple hardcoded resources for simple example
    resources: {
      es: {
        translation: translations,
      },
    },
  });

export default i18next


// WEBPACK FOOTER //
// ./src/i18n/I18n.js